import { requestGet } from "@/utils/dva16";
import { EGet, MNotes, RSetState } from "./contants";

export default {
	namespace: MNotes,
	state: {
		marketNotes: null,
		load: false,
	},
	reducers: {
		[RSetState](state, { payload }) {
			return {
				...state,
				...payload,
			};
		},
	},
	effects: {
		async [EGet]({ payload, callback }, { call, reducer, select, effect }) {
			reducer(RSetState, { load: true });
			let res = await requestGet("marketNotes", payload);
			reducer(RSetState, { marketNotes: res, load: false });
		},
	},
};
